const CAP11 = {
  id: 11,
  slug: "cap11-tipos-de-blockchain",
  title: "Capítulo 11 — Tipos de Blockchain",
  sections: [
    {
      heading: "¿Por qué existen distintos tipos de blockchain?",
      text: [
        "No todas las blockchains funcionan igual ni sirven para los mismos propósitos.",
        "Algunas son **abiertas y públicas**, como Bitcoin y Ethereum, mientras que otras son **privadas o controladas**, usadas por empresas, gobiernos o proyectos internos.",
        "También existen modelos intermedios como las **blockchains de consorcio** o las **híbridas**, que combinan características de los modelos anteriores.",
        "Comprender estas diferencias es clave para elegir la tecnología adecuada según el **nivel de seguridad, privacidad, transparencia, escalabilidad o control** que se necesite."
      ]
    },
    {
      heading: "Comparativa general de los tipos de blockchain",
      table: {
        columns: [
          "Característica",
          "Pública",
          "Privada",
          "Consorcio",
          "Híbrida"
        ],
        rows: [
          {
            "Característica": "Abierta y accesible a todos",
            "Pública": "✔️",
            "Privada": "No",
            "Consorcio": "No",
            "Híbrida": "Selectivo"
          },
          {
            "Característica": "Descentralización",
            "Pública": "✔️",
            "Privada": "No",
            "Consorcio": "Parcial",
            "Híbrida": "Parcial"
          },
          {
            "Característica": "Autoridad central",
            "Pública": "No",
            "Privada": "✔️",
            "Consorcio": "✔️",
            "Híbrida": "Algunas veces"
          },
          {
            "Característica": "Seguridad",
            "Pública": "✔️",
            "Privada": "✔️",
            "Consorcio": "✔️",
            "Híbrida": "✔️"
          },
          {
            "Característica": "Transparencia",
            "Pública": "✔️",
            "Privada": "Limitada",
            "Consorcio": "Parcial",
            "Híbrida": "Parcial"
          },
          {
            "Característica": "Privacidad",
            "Pública": "Algunas veces",
            "Privada": "✔️",
            "Consorcio": "✔️",
            "Híbrida": "✔️"
          },
          {
            "Característica": "Escalabilidad",
            "Pública": "Parcial",
            "Privada": "✔️",
            "Consorcio": "✔️",
            "Híbrida": "✔️"
          },
          {
            "Característica": "Rendimiento",
            "Pública": "Algunas veces",
            "Privada": "✔️",
            "Consorcio": "✔️",
            "Híbrida": "✔️"
          },
          {
            "Característica": "Interoperabilidad",
            "Pública": "Algunas veces",
            "Privada": "✔️",
            "Consorcio": "Parcial",
            "Híbrida": "Parcial"
          },
          {
            "Característica": "Trazabilidad",
            "Pública": "✔️",
            "Privada": "Algunas veces",
            "Consorcio": "Parcial",
            "Híbrida": "✔️"
          },
          {
            "Característica": "Incentivos",
            "Pública": "✔️",
            "Privada": "No",
            "Consorcio": "No",
            "Híbrida": "No"
          },
          {
            "Característica": "Ejemplos",
            "Pública": "Bitcoin, Ethereum",
            "Privada": "Hyperledger, Quorum",
            "Consorcio": "Corda",
            "Híbrida": "Dragonchain"
          }
        ]
      }
    },
    {
      heading: "¿Cuándo usar cada tipo?",
      bluepoints: [
        "🌐 **Blockchain pública** → Ideal para proyectos abiertos, criptomonedas, redes descentralizadas y alta transparencia.",
        "🏢 **Blockchain privada** → Adecuada para empresas, control de acceso, bases de datos seguras internas.",
        "🤝 **Blockchain de consorcio** → Perfecta para colaboración entre varias organizaciones (bancos, hospitales, cadenas de suministro).",
        "🔄 **Blockchain híbrida** → Útil cuando se necesita privacidad con opción de auditoría o transparencia pública."
      ]
    },
    {
      heading: "Resumen simple",
      text: [
        "Piensa en una blockchain como una reunión:",
        "🔹 Pública: cualquier persona puede entrar, hablar y verificar.",
        "🔹 Privada: solo personas invitadas por una empresa.",
        "🔹 Consorcio: varias organizaciones comparten el control.",
        "🔹 Híbrida: algunas partes son públicas y otras privadas.",
        "Cada tipo existe porque **no todas las soluciones necesitan el mismo nivel de descentralización, privacidad o control.**"
      ]
    }
  ]
};

export default CAP11;
